module.exports = "/public/webpack/img/icon_help_categories_sites_3297a467d54679d0804e22667b07dc3086.png";